import OliverText from "@builder/components/general/OliverText";
import { getAllUI } from "@builder/store/slices/BuilderSlice/builderMap";
import { useAppSelector } from "@builder/store/store";
import { CSSProperties, useEffect, useState } from "react";
import OliverImage from "../../OliverImage";
import { getCurrentLayer } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { InstalledBuilderElement } from "@builder/store/slices/builderElementsInstalledApiSlice";

const allUIComponents = Object.values(getAllUI()).flatMap(v => v);

function UIDragPreviewButton({ compKey, dynamicElement }: { compKey: string; dynamicElement?: InstalledBuilderElement }) {
    const component = allUIComponents.find(c => c.key === compKey);
    if (!component) return;
    return (
        <>
            <OliverImage src={component.icon} />
            <OliverText text={dynamicElement?.name || component.label} size="xs" weight="medium-heavy" />
        </>
    );
}

function JustIcon({ compKey }: { compKey: string }) {
    const component = allUIComponents.find(c => c.key === compKey);
    if (!component) return null;
    return <OliverImage src={component.icon} />;
}

export default function FloatingDraggedElement() {
    const currentlyDraggedUI = useAppSelector(state => state.builder.draggedUIComponent);

    const currentlyDraggedUIKey = currentlyDraggedUI?.key;
    const currentlyDraggedUIDynamicElement = currentlyDraggedUI?.dynamicElement;

    const currentlyDraggedNodeID = useAppSelector(state => state.builder.draggedNode);
    const components = useAppSelector(getCurrentLayer).components;

    const relevantUIName = currentlyDraggedUIKey || (currentlyDraggedNodeID && components[currentlyDraggedNodeID]?.name) || null;

    const [offsetX, setOffsetX] = useState(0);
    const [offsetY, setOffsetY] = useState(0);

    useEffect(() => {
        if (!relevantUIName) return;

        const eventHandlr = (e: DragEvent) => {
            setOffsetX(e.clientX);
            setOffsetY(e.clientY);
        };

        document.body.addEventListener("dragover", eventHandlr);

        return () => document.body.removeEventListener("dragover", eventHandlr);
    }, [relevantUIName]);

    if (!relevantUIName) {
        return null;
    }

    const transform = `translate(${offsetX}px, ${offsetY}px) rotate(-10deg)`;

    const DynamicSpinnedButtonStyles: CSSProperties = {
        transform,
        WebkitTransform: transform,
        opacity: 1,
        height: "34px",
        width: "200px",
        display: "flex",
        backgroundColor: "var(--theme-bg)",
        position: "fixed",
        pointerEvents: "none",
        left: -100,
        top: -25,
        border: "1px solid var(--theme-border-color)",
        borderRadius: "4px",
        padding: "5px 10px",
        gap: "8px",
        alignItems: "center",
        boxShadow: "0px 15px 30px 0px #3E134D17",
        zIndex: 1000
    };

    const DynamiciconStyles: CSSProperties = {
        transform,
        WebkitTransform: transform,
        opacity: 1,
        position: "fixed",
        pointerEvents: "none",
        boxShadow: "0px 15px 30px 0px #3E134D17"
    };

    if (!offsetX || !offsetY) {
        return;
    }

    if (currentlyDraggedNodeID) {
        return (
            <div style={DynamiciconStyles}>
                <JustIcon compKey={relevantUIName} />
            </div>
        );
    }

    return (
        <div style={DynamicSpinnedButtonStyles}>
            <UIDragPreviewButton compKey={relevantUIName} dynamicElement={currentlyDraggedUIDynamicElement} />
        </div>
    );
}
